import { render } from "./ComponentTypePicker.vue?vue&type=template&id=d8ae32b0"
import script from "./ComponentTypePicker.vue?vue&type=script&lang=js"
export * from "./ComponentTypePicker.vue?vue&type=script&lang=js"

import "./ComponentTypePicker.vue?vue&type=style&index=0&id=d8ae32b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__